import { render, staticRenderFns } from "./table.vue?vue&type=template&id=2279cb25&scoped=true&"
import script from "./table.js?vue&type=script&lang=js&"
export * from "./table.js?vue&type=script&lang=js&"
import style0 from "./table.scss?vue&type=style&index=0&id=2279cb25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2279cb25",
  null
  
)

export default component.exports